import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { RpcControlsModule } from '@core-controls/controls.module';
import { TranslationLoaderService } from '@core-services/translation-loader.service';

import { SimpleDialogComponent } from '@core-utils/simple-dialog/components/simple-dialog/simple-dialog.component';
import { locale as english } from '@core-utils/simple-dialog/i18n/en';

@NgModule({
    imports: [
    // Library Modules
    CommonModule,
    TranslateModule,
    RpcControlsModule,
    SimpleDialogComponent
]
})
export class SimpleDialogModule {
    constructor(private readonly translationLoaderService: TranslationLoaderService) {
        this.translationLoaderService.loadTranslations(english);
    }
}